import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function useConsumedStatusFn() {
  const [t] = useTranslation(['common', 'reserve']);

  const fn = useCallback((value: boolean) => {
    if (value) {
      return (
        <div className="inline-flex font-bold text-accent-darker">
          {t('reserve:labels.consumed')}
        </div>
      );
    }
    return (
      <div className="inline-flex font-bold text-primary-food">
        {t('reserve:labels.reserved')}
      </div>
    );
  }, [t]);

  return fn;
}
